<h5 class="titulo">
  Informe pelo menos um número caso <br />
  precisemos entrar em contato
</h5>
<form class="form" [formGroup]="form" (submit)="prosseguir();">
  <label class="form__label" for="nome">Nome do contato *
    <input class="form__input" type="text" formControlName="nome" name="nome" required>
  </label>
  <label class="form__label" for="email">Email do contato *
    <input class="form__input" type="text" formControlName="email" name="email" required>
  </label>
  <label class="form__label" for="celular">Celular *
    <input class="form__input" type="text" formControlName="celular" name="celular" mask="(00) 00000-0000">
  </label>
  <label class="form__label" for="telefone">Telefone
    <input class="form__input" type="text" name="telefone" formControlName="telefone" mask="(00) 0000-0000">
  </label>
  <label class="form__label" for="telefoneAlternativo">Telefone alternativo
    <input class="form__input" type="text" name="telefoneAlternativo" formControlName="telefoneAlternativo"
      mask="(00) 0000-0000">
  </label>
  <app-botao-submit [disabled]="form.invalid">Continuar
  </app-botao-submit>
</form>
<app-indicador-circular-paginacao class="progresso" [quantidadeDePaginas]="3"
  [paginaAtiva]="3"></app-indicador-circular-paginacao>